<template>
  <footer class="footer">
    <div class="footer-stars"></div>
    <div class="footer-container">
      <div class="footer-main">
        <!-- 关于大会 -->
        <div class="footer-section">
          <h4 class="footer-title">关于大会</h4>
          <p class="footer-desc">
            本次论坛旨在促进学术交流、凝聚科研合力，推动内蒙古地区天文与物理学科的快速发展，提升区域在国内外天文研究中的影响力。
          </p>
        </div>

        <!-- 快速链接 -->
        <div class="footer-section">
          <h4 class="footer-title">快速链接</h4>
          <ul class="footer-links">
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/about">大会介绍</router-link></li>
            <li><router-link to="/schedule">大会日程</router-link></li>
            <li><router-link to="/paper">摘要提交</router-link></li>
            <li><router-link to="/notice">参会须知</router-link></li>
          </ul>
        </div>

        <!-- 重要日期 -->
        <div class="footer-section">
          <h4 class="footer-title">重要日期</h4>
          <ul class="footer-dates" v-if="conferenceInfo">
            <li v-if="conferenceInfo.paper_deadline">
              <span class="date-label">摘要提交截止时间</span>
              <span class="date-value">{{ conferenceInfo.paper_deadline }}</span>
            </li>
            <li v-if="conferenceInfo.early_bird_deadline">
              <span class="date-label">线上缴费截止时间</span>
              <span class="date-value">{{ conferenceInfo.early_bird_deadline }}</span>
            </li>
            <li v-if="conferenceInfo.registration_deadline">
              <span class="date-label">报名截止日期</span>
              <span class="date-value">{{ conferenceInfo.registration_deadline }}</span>
            </li>
            <li v-if="conferenceInfo.start_date && conferenceInfo.end_date">
              <span class="date-label">大会召开时间</span>
              <span class="date-value">{{ formatConferenceDate(conferenceInfo.start_date, conferenceInfo.end_date) }}</span>
            </li>
          </ul>
        </div>

        <!-- 联系方式 -->
        <!-- <div class="footer-section">
          <h4 class="footer-title">联系我们</h4>
          <ul class="footer-contact">
            <li>
              <i class="el-icon-phone-outline"></i>
              <span>010-88888888</span>
            </li>
            <li>
              <i class="el-icon-message"></i>
              <span>astronomy@example.com</span>
            </li>
            <li>
              <i class="el-icon-time"></i>
              <span>工作日 9:00 - 18:00</span>
            </li>
          </ul>
        </div> -->
      </div>

      <div class="footer-bottom">
        <div class="footer-copyright">
          <p>&copy; 2025 内蒙古大学 版权所有</p>
          <!-- <p class="footer-icp">京ICP备XXXXXXXX号</p> -->
        </div>
        <div class="footer-partners" v-if="conferenceInfo && conferenceInfo.organizer">
          <span>主办单位：{{ conferenceInfo.organizer }}</span>
        </div>
        <div class="footer-partners" v-else>
          <span>主办单位：内蒙古大学 | 中国科学院国家天文台</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { conferenceApi } from '@/api'

export default {
  name: 'Footer',
  data() {
    return {
      conferenceInfo: null
    }
  },
  created() {
    this.fetchConferenceInfo()
  },
  methods: {
    // 获取会议信息
    async fetchConferenceInfo() {
      try {
        const res = await conferenceApi.getDetail(1)
        this.conferenceInfo = res.data || null
      } catch (error) {
        console.error('获取会议信息失败', error)
      }
    },
    // 格式化会议日期
    formatConferenceDate(startDate, endDate) {
      // 将日期字符串转换为Date对象
      const start = new Date(startDate)
      const end = new Date(endDate)
      
      // 获取年份
      const year = start.getFullYear()
      
      // 获取月和日
      const startMonth = start.getMonth() + 1 // 月份从0开始，需要+1
      const startDay = start.getDate()
      const endMonth = end.getMonth() + 1
      const endDay = end.getDate()
      
      // 如果是同一个月
      if (startMonth === endMonth) {
        return `${year}年${startMonth}月${startDay}日至${endDay}日`
      } else {
        // 如果不是同一个月
        return `${year}年${startMonth}月${startDay}日至${endMonth}月${endDay}日`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(180deg, #0d1642 0%, #1a237e 100%);
  color: rgba(255, 255, 255, 0.9);
  padding: 60px 0 0;
  margin-top: auto;
  position: relative;
  overflow: hidden;
}

.footer-stars {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(1px 1px at 10% 20%, rgba(255, 255, 255, 0.5) 1px, transparent 1px),
    radial-gradient(1px 1px at 30% 50%, rgba(255, 255, 255, 0.4) 1px, transparent 1px),
    radial-gradient(1px 1px at 50% 30%, rgba(255, 255, 255, 0.3) 1px, transparent 1px),
    radial-gradient(1px 1px at 70% 70%, rgba(255, 255, 255, 0.5) 1px, transparent 1px),
    radial-gradient(1px 1px at 90% 40%, rgba(255, 255, 255, 0.4) 1px, transparent 1px),
    radial-gradient(2px 2px at 15% 80%, rgba(255, 255, 255, 0.3) 1px, transparent 1px),
    radial-gradient(2px 2px at 85% 10%, rgba(255, 255, 255, 0.4) 1px, transparent 1px);
  background-size: 200px 200px;
  pointer-events: none;
  animation: twinkle 4s ease-in-out infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.footer-main {
    // display: flex;
    // justify-content: space-between;
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 1fr;
  gap: 30px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-section {
  .footer-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #fff;
    position: relative;
    padding-bottom: 10px;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 2px;
      background: linear-gradient(90deg, #ffd700, #7c4dff);
    }
  }

  .footer-desc {
    font-size: 14px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 20px;
  }

  .footer-social {
    display: flex;
    gap: 12px;

    .social-link {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      transition: all 0.3s;

      &:hover {
        background: #7c4dff;
        transform: translateY(-3px);
      }
    }
  }
}

.footer-links {
  list-style: none;

  li {
    margin-bottom: 12px;

    a {
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      font-size: 14px;
      transition: all 0.3s;
      display: inline-flex;
      align-items: center;

      &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #7c4dff;
        margin-right: 10px;
        transition: all 0.3s;
      }

      &:hover {
        color: #fff;
        padding-left: 5px;

        &::before {
          background: #ffd700;
        }
      }
    }
  }
}

.footer-dates {
  list-style: none;

  li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 14px;

    .date-label {
      color: rgba(255, 255, 255, 0.7);
    }

    .date-value {
      color: #ffd700;
      font-weight: 500;
    }
  }
}

.footer-contact {
  list-style: none;

  li {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);

    i {
      font-size: 16px;
      margin-right: 10px;
      color: #7c4dff;
    }
  }
}

.footer-bottom {
  padding: 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);

  .footer-copyright {
    p {
      margin: 0;
    }

    .footer-icp {
      margin-top: 5px;
      font-size: 12px;
    }
  }

  .footer-partners {
    display: flex;
    align-items: center;
    gap: 10px;

    .divider {
      opacity: 0.3;
    }
  }
}

@media screen and (max-width: 992px) {
  .footer-main {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 576px) {
  .footer {
    padding: 40px 0 0;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 15px;

    .footer-partners {
      flex-direction: column;
      gap: 5px;

      .divider {
        display: none;
      }
    }
  }
}
</style>
